var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{staticClass:"loading-bar-wrap"},[_c('div',{staticClass:"loading-bar",style:({width: (_vm.progress + "%")})})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }